export default class types {
	static API_CALL = 'API_CALL';

	static SET_API_CALL_PENDING = `${types.API_CALL}/SET_API_CALL_PENDING`;

	static SET_API_CALL_ERROR = `${types.API_CALL}/SET_API_CALL_ERROR`;

	static RESET_ALL_ERRORS = `${types.API_CALL}/RESET_ALL_ERRORS`;
}
